import { motion } from 'framer-motion';
import classNames from 'classnames';
import { IconCheck } from '@tabler/icons-react';
import { itemVariants, optionHover, optionTap } from '@shared/lib/onboarding-motion';
import s from './onboarding-option-card.module.scss';

export const OnboardingOptionCard = ({
	checked,
	onClick,
	children,
	icon: Icon,
	className,
	...props
}) => {
	return (
		<motion.button
			type="button"
			className={classNames(s.card, checked && s.active, className)}
			onClick={onClick}
			variants={itemVariants}
			whileHover={optionHover}
			whileTap={optionTap}
			{...props}
		>
			{Icon ? (
				<Icon className={s.icon} size={20} />
			) : (
				<span className={classNames(s.check, checked && s.checked)}>
					{checked ? <IconCheck size={14} stroke={3} /> : null}
				</span>
			)}
			<span className={s.label}>{children}</span>
		</motion.button>
	);
};
